import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import "./service-alumni-award.css"
import PageHeader from "../../components/PageHeader"
import About from "./About"
import AwardWinners from "./AwardWinners"
import WinnersPagination from "./WinnersPagination"
import { fetchPageContent } from "../../features/distinguished-alumni-service-award/distinguishedAlumniServiceAwardSlice"
import { apiBaseURI } from "../../config"

const ServiceAlumniAward = () => {
    const dispatch = useDispatch()

    const { pageContent } = useSelector(
        (state) => state.distinguishedAlumniServiceAwardPage
    )

    useEffect(() => {
        dispatch(fetchPageContent("distinguished-alumni-service-award"))
    }, [dispatch])

    return (
        <>
            <PageHeader
                image={`${apiBaseURI}${pageContent.image_url}`}
                title="Distinguished Alumni Service Award"
                position="center"
            />

            <About about={pageContent.content} />
            <AwardWinners />
            <WinnersPagination />
        </>
    )
}

export default ServiceAlumniAward
